import {Campaign} from '../../../../types/src';

export function isCampaignMessageReqeust(campaign: Campaign) {
  return campaign && campaign.type && campaign.type.includes('message_request');
}
